export default "__VITE_ASSET__DVk4QkGJ__"